import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { LOGIN_PATH } from '../RouteConstants';
import { useAuthenticate } from '../../hooks';

const PrivateRoute = () => {
    const { auth } = useAuthenticate();
    return auth ? <Outlet /> : <Navigate to={LOGIN_PATH} />;
};

export default PrivateRoute;
